// import URL_LIBRARY from '@/config/pages/urlLibrary.json';
/* TODO: ESTO PUEDE VENIR DE BIT */
import { enviromentKey } from '@/constants/constants';

export const goToUpgradePage = () => {
  if (location.hash.startsWith('#/webviews')) {
    window.location.href =
      'https://appweb.movistar.es/pages/upgrade-permissions?origin=https%3A%2F%2Fappweb.movistar.es%2F_%2Faccount%2Fcore%2Fwebviews%2Fv2.php%2F%3Fid%3Dnt-catalogue%26p%3Dflow';
  } else {
    // const pathURL = URL_LIBRARY.find((URL) => URL.loader === 'Upgrade');
    const pathURL = null;
    window.location.href = `#${process.env.NEXT_PUBLIC_PROJECT_BASE_PATH}${pathURL.pathName}`;
  }
};
export const logInNeeded = () => {
  // const pathURL = URL_LIBRARY.find((URL) => URL.loader === 'SessionExpired');
  const pathURL = null;
  window.location.href = `#${process.env.NEXT_PUBLIC_PROJECT_BASE_PATH}${pathURL.pathName}`;
};
